<template>
  <div>
    <div class="" v-if="item" v-disable-all="isReadonly">
      <div class="row my-3">
        <div class="col  col-md-12">
          <div class="form-group required">
            <div class="form-group required">
              <label class="control-label">Организация</label>
              <Select2
                  class="select2"
                  :options="vacancyList"
                  :settings="select2Settings"
                  v-model="item.vacancyId"
                  style="width: 100%"
              />
              <div class="invalid-msg" v-if="v$.item.vacancyId.$error">Поле обязательно для заполнения</div>
            </div>
          </div>
        </div>

        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата</label>
            <date-component :disabled="isReadonly" v-model="item.dateMeeting" :required="true"/>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <component-input
                label="Контактное лицо (ФИО, должность)"
                v-model="item.contactPerson"
                placeholder="Введите ФИО и должность"
                required/>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <component-input
                label="Контакты (tel, e-mail)"
                v-model="item.contactInfo"
                placeholder="Введите контактные данные"
                required/>
          </div>
        </div>

        <div class="col  col-md-12">
          <div class="form-group required">
            <label class='control-label'>Итог общения</label>
            <div><textarea class="form-control" v-model="item.result"/></div>
            <div class="invalid-msg" v-if="v$.item.result.$error">Поле обязательно для заполнения</div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-right d-flex align-items-center">
      <button-component class="btn btn-primary mx-2" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
      <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть</button-component>
    </div>
  </div>
</template>
<script>
import API from '../api/applicantHistory'
import APIVacancy from '../api/vacancy'
import Constants from '../../../common/constants'
import {required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import ButtonComponent from "../../../common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import disableAll from "@/common/directives/disable-all";

const selectValidator = (value) => value > 0;

export default {
  name: "ApplicantHistoryCard",
  components: {
    ButtonComponent,
    DateComponent,
    ComponentInput
  },
  directives: {
    'disable-all': disableAll
  },
  props: {
    applicantId: Number,
    cardId: {
      type: Number,
      required: false,
      default: null
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loadVacancyList();
    this.loadPage();
  },
  data() {
    return {
      item: {
        applicantId: 0,
        dateMeeting: null,
        vacancyId: 0,
      },
      vacancyList: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ]
    };
  },
  methods: {
    loadVacancyList() {
      var self = this;
      APIVacancy.search({pageNumber: 1, pageSize: 10000}).then(response => {
        console.log(response.data);
        if (response.data && response.data.items) {
          response.data.items.forEach((i) => this.vacancyList.push({id: i.id, text: i.name}));
        }
        console.log(self.vacancyList);
      });
    },
    loadPage() {
      var self = this;
      if (self.cardId) {
        API.find(self.cardId).then(response => {
          self.item = response.data;
        });
      } else {
        self.item.applicantId = self.applicantId;
      }
    },
    save() {
      var self = this;

      self.v$.$touch();
      if (self.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      API.save(self.item).then(function (response) {
        Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          self.$emit('save');
        }
      });
    },
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        vacancyId: {required, selectValidator},
        result: {required}
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
</style>